/*
 * Back-in-stock waitlist (snippets/notify-me.liquid).
 * Follows the size picked through the theme's own variantChanged event (product page and
 * quick buy), and sends the email and size to Klaviyo's client back-in-stock subscription
 * endpoint (public site ID). Klaviyo's back-in-stock flow then sends one email when that size
 * is back. No marketing consent is asked for or given.
 * Sizes joined in this visit are remembered for the tab.
 */
(function ($) {
  if (!$ || window.notifyMeReady) return;
  window.notifyMeReady = true;

  var SIGNED_UP_KEY = 'notify-me-signed-up';
  var ERROR_TEXT = "Couldn't add you just now. Please try again.";

  function readSignedUp() {
    try {
      var list = JSON.parse(sessionStorage.getItem(SIGNED_UP_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function rememberSignedUp(id) {
    try {
      var list = readSignedUp();
      if (list.indexOf(id) === -1) {
        list.push(id);
        sessionStorage.setItem(SIGNED_UP_KEY, JSON.stringify(list));
      }
    } catch (e) {
      // storage blocked: the note still shows until the size changes
    }
  }

  // Quick buy opens in a panel of fixed height; the theme re-measures it on 'changedsize'.
  // Only after the shopper does something: while quick buy is still opening, a resize would
  // interrupt the theme's own slide-down.
  function resizeQuickbuy(el) {
    $(el).closest('.quickbuy-container').trigger('changedsize');
  }

  function showDone(el, done) {
    el.querySelector('.notify-me__join').hidden = done;
    el.querySelector('.notify-me__done').hidden = !done;
  }

  function reset(el) {
    el.querySelector('.notify-me__message').textContent = '';
    showDone(el, !!el.dataset.variant && readSignedUp().indexOf(el.dataset.variant) !== -1);
  }

  // The theme triggers variantChanged on the size selector each time the size changes.
  $(document).on('variantChanged', 'select.original-selector', function (e, variant) {
    var el = $(this).closest('form').find('[data-notify-me]')[0];
    if (!el) return;
    var show = !!variant && variant.available === false && variant.inventory_management === 'shopify';
    var id = show ? String(variant.id) : '';
    if (id === el.dataset.variant && show === !el.hidden) return;
    el.dataset.variant = id;
    el.hidden = !show;
    if (show && el.dataset.sized === 'true') {
      $(el).find('[data-notify-line]').text("We'll email you once when " + variant.title + ' is back.');
    }
    reset(el);
    resizeQuickbuy(el);
  });

  function submit(el) {
    var input = el.querySelector('.notify-me__input');
    var button = el.querySelector('.notify-me__submit');
    var message = el.querySelector('.notify-me__message');
    var variantId = el.dataset.variant;
    var email = input.value.trim();

    if (!email || !input.checkValidity()) {
      input.reportValidity();
      return;
    }
    // One request at a time: a second Enter would sign up twice.
    if (!variantId || el.dataset.busy) return;

    el.dataset.busy = '1';
    button.setAttribute('aria-busy', 'true');
    message.textContent = '';

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + encodeURIComponent(el.dataset.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL']
          },
          relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
        }
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Klaviyo ' + response.status);
        rememberSignedUp(variantId);
        // The shopper picked another size while this was on its way: remembered, nothing to show.
        if (el.dataset.variant !== variantId) return;
        showDone(el, true);
        resizeQuickbuy(el);
        el.querySelector('.notify-me__done').focus();
      })
      .catch(function () {
        if (el.dataset.variant === variantId) message.textContent = ERROR_TEXT;
      })
      .then(function () {
        delete el.dataset.busy;
        button.removeAttribute('aria-busy');
      });
  }

  $(document).on('click', '[data-notify-me] .notify-me__submit', function (e) {
    e.preventDefault();
    submit($(this).closest('[data-notify-me]')[0]);
  });

  // Enter in the field would otherwise submit the product form around it.
  $(document).on('keydown', '[data-notify-me] .notify-me__input', function (e) {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    submit($(this).closest('[data-notify-me]')[0]);
  });

  // Each block once (page load, and quick buy content added later), so a later cart request
  // never resets a field someone is typing in.
  function initAll() {
    $('[data-notify-me]').each(function () {
      if (this.dataset.ready) return;
      this.dataset.ready = '1';
      if (!this.hidden) reset(this);
    });
  }
  $(initAll);
  $(document).on('ajaxComplete', initAll);
})(window.jQuery);
